export default {"buttonWrapper":"IxuEY","button1":"SyzxE","button3":"DDo9I","buyProductText":"_5a-F9","button2":"SJTdS","icon":"SMyZq","customButton":"XRGtK"};